// extracted by mini-css-extract-plugin
export default {"tagContainer":"tags-module--tagContainer--5eBht","tag":"tags-module--tag--GZIPY"};